module.exports = __webpack_public_path__ + "files/ad2859c57dd22f894bfae327288cb84e.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/places-3.png
// module id = 1471
// module chunks = 60